export function fileSizeNum(size){
    size = size || 0;
    var fileSize =(size / 1024).toFixed(1);
    if(fileSize>1024){
        fileSize =(fileSize / 1024).toFixed(2) +'MB';
    }else{
        fileSize = fileSize+'KB';
    }
    return fileSize
}


export function isPhone(){
    var system = { 
        win: false, 
        mac: false, 
        xll: false, 
        ipad:false 
    }; 
    var p = navigator.platform; 
    system.win = p.indexOf("Win") == 0; 
    system.mac = p.indexOf("Mac") == 0; 
    system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
    system.ipad = (navigator.userAgent.match(/iPad/i) != null)?true:false; 
    //跳转语句，如果是手机访问就自动跳转到wap.baidu.com页面 
    if (system.win || system.mac || system.xll||system.ipad) { 
        return false;
    } else { 
       return true;
    }
}

export function isIos(){
    if(/iPhone|iPod/i.test(navigator.userAgent)) {
        return true;
    } else {
        return false;
    }
}

export function isWeixin(){
    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 || typeof navigator.wxuserAgent !== 'undefined') {
        return true;
    }
    return false;
}

export function wechatAuthorize(){
      //重定向URL
      var re_uri = encodeURIComponent("https://www.caiyunapp.com/wechat_login?re_url=" + location.href);
      var re_uri = encodeURIComponent("https://www.caiyunapp.com/wechat_login?re_url=" + location.href);
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?" +
        "appid=wx9b768083e39b41f5&redirect_uri=" + re_uri + "&response_type=code&scope=snsapi_userinfo&state=LOGIN#wechat_redirect";
      location.href = url;
}


// WEBPACK FOOTER //
// ./src/api/public.js